import { Image, Input } from '@starsoft/common/components';
import styles from '../styles.module.scss';
import skeleton from './styles.module.scss';

export default function MethodCardSkeleton() {
  return (
    <div className={`${styles.container} ${styles['container--loading']}`}>
      <div className={styles.container__row}>
        <div className={skeleton.image} />
        <div
          className={`${styles.container__column} ${styles['container__column--gapped']}`}
        >
          <div className={styles.container__name}>
            <div className={skeleton.name} />

            <Image width={80} height={12} secondarySkeleton />
          </div>
          <div className={skeleton.description} />
        </div>
      </div>
      <Input type="radio" isLoading secondarySkeleton />
    </div>
  );
}
